export default "__VITE_ASSET__c5f1ecc3__"